import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";
import { ListSearchReqBody, MapQueryParams } from "./MapGateway";

interface PlaceImageQueryParams {
    mapid: string;
    XID: string;
}

class PlaceImageGateway extends Gateway {
    protected readonly _contextPath = "map/place/image";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        list: "list",
        count: "count",
        add: "add",
    };


    public async reqAddPlaceImage(param: PlaceImageQueryParams, body: FormData): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.add,
            ...param,
        };
        
        return await this.request(Method.POST, undefined, queryParam, body);
    }
}

export { PlaceImageGateway, type PlaceImageQueryParams };
